module.exports = __webpack_public_path__ + "static/img/ic_linechart_blurred.1ccf805d.svg";